import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  archivedActiveCrop: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTIVE_ARCHIVED_CROPS_SUCCESS:
      return Object.assign({}, action.payload);
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.ACTIVE_ARCHIVED_CROPS:
          return Object.assign({}, state, { isLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.ACTIVE_ARCHIVED_CROPS:
          return Object.assign({}, state, { isLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
